import React, { useState, useCallback } from 'react';
import {
    EnvelopeIcon,
    TrashIcon,
    CheckCircleIcon,
    ExclamationCircleIcon
} from '@heroicons/react/24/outline';
import { useFirestore } from '../../hooks/useFirestore';
import { collection, query, orderBy, deleteDoc, doc, updateDoc, getDocs } from 'firebase/firestore';
import { db } from '../../firebase/config';
import Loading from '../../components/common/Loading';
import './ViewInquiries.css';

const ViewInquiries = () => {
    const fetchInquiries = useCallback(async () => {
        const q = query(collection(db, 'inquiries'), orderBy('createdAt', 'desc'));
        const snapshot = await getDocs(q);
        return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    }, []);

    const { data: inquiries, loading, refresh } = useFirestore(fetchInquiries, []);

    const handleStatusUpdate = async (id, newStatus) => {
        try {
            await updateDoc(doc(db, 'inquiries', id), { status: newStatus });
            refresh();
        } catch (error) {
            console.error('Error updating inquiry status:', error);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('هل أنت متأكد من حذف هذا الاستفسار؟')) {
            try {
                await deleteDoc(doc(db, 'inquiries', id));
                refresh();
            } catch (error) {
                console.error('Error deleting inquiry:', error);
            }
        }
    };

    if (loading && !inquiries) return <Loading />;

    return (
        <div className="view-inquiries">
            <h1 className="admin-page-title">طلبات الاستفسار ({inquiries?.length || 0})</h1>

            <div className="inquiries-list">
                {inquiries?.length === 0 ? (
                    <div className="no-inquiries shadow-premium">
                        <EnvelopeIcon className="no-inquiries-icon" />
                        <p>لا توجد استفسارات جديدة حالياً</p>
                    </div>
                ) : (
                    inquiries?.map((inquiry) => (
                        <div key={inquiry.id} className={`inquiry-card shadow-premium status-${inquiry.status}`}>
                            <div className="inquiry-header">
                                <div className="inquiry-user">
                                    <h3>{inquiry.name}</h3>
                                    <span className="inquiry-date">
                                        {new Date(inquiry.createdAt).toLocaleDateString('ar-EG', {
                                            year: 'numeric',
                                            month: 'long',
                                            day: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit'
                                        })}
                                    </span>
                                </div>
                                <div className="inquiry-badges">
                                    <span className={`status-badge ${inquiry.status}`}>
                                        {inquiry.status === 'new' ? 'جديد' : 'تم التواصل'}
                                    </span>
                                </div>
                            </div>

                            <div className="inquiry-body">
                                <div className="inquiry-detail">
                                    <strong>البريد الإلكتروني:</strong>
                                    <a href={`mailto:${inquiry.email}`}>{inquiry.email}</a>
                                </div>
                                <div className="inquiry-detail">
                                    <strong>رقم الهاتف:</strong>
                                    <a href={`tel:${inquiry.phone}`}>{inquiry.phone}</a>
                                </div>
                                <div className="inquiry-message">
                                    <strong>الرسالة:</strong>
                                    <p>{inquiry.message}</p>
                                </div>
                            </div>

                            <div className="inquiry-actions">
                                {inquiry.status === 'new' ? (
                                    <button
                                        className="btn-status contact"
                                        onClick={() => handleStatusUpdate(inquiry.id, 'contacted')}
                                    >
                                        <CheckCircleIcon className="btn-icon" />
                                        <span>تم التواصل</span>
                                    </button>
                                ) : (
                                    <button
                                        className="btn-status undo"
                                        onClick={() => handleStatusUpdate(inquiry.id, 'new')}
                                    >
                                        <ExclamationCircleIcon className="btn-icon" />
                                        <span>تغيير لجديد</span>
                                    </button>
                                )}
                                <button
                                    className="btn-delete"
                                    onClick={() => handleDelete(inquiry.id)}
                                >
                                    <TrashIcon className="btn-icon" />
                                    <span>حذف</span>
                                </button>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default ViewInquiries;
